import { render } from "./PerfilFichaEdit.vue?vue&type=template&id=2e777736"
import script from "./PerfilFichaEdit.vue?vue&type=script&lang=ts"
export * from "./PerfilFichaEdit.vue?vue&type=script&lang=ts"
script.render = render

export default script